import { BookOpen, Feather, Sailboat, Waves } from 'lucide-react';

export function OfferIcon({ type, size = 118 }: { type: 'book' | 'wave' | 'boat' | 'feather'; size?: number }) {
  const common = { size, strokeWidth: 1.15 };
  return (
    <div className="offer-illustration" aria-hidden="true">
      <span className="soft-disc" />
      {type === 'book' && <BookOpen {...common} />}
      {type === 'wave' && <Waves {...common} />}
      {type === 'boat' && <Sailboat {...common} />}
      {type === 'feather' && <Feather {...common} />}
      <span className="spark">✦</span>
    </div>
  );
}

export default OfferIcon;
